import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OOIntegratorPrice } from "src/app/shared/models/OOIntegratorPrice.item";
import { v4 as uuidv4 } from "uuid";

@Component({
	selector: "app-integration-third-party-integration-setup",
	templateUrl: "./integration-third-party-integration-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class IntegrationThirdPartyIntegrationSetupComponent implements OnInit {
	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	integratorPriceSelected: OOIntegratorPrice;

	constructor(public app: AppService, public venueSvc: OOVenueService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {}

	newIntegratorPrice() {
		this.integratorPriceSelected = new OOIntegratorPrice({
			venueKey: this.venueSvc.venueKey,
			key: uuidv4(),
		});
	}

	integratorPriceDelete(rec: OOIntegratorPrice) {
		this.app.confirmation.confirm({
			message: `Are you sure you want to delete this 3rd Party Price?`,
			accept: async () => {
				this.venueSvc.integratorPriceDelete(rec);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}
}
